// src/client/components/Pill.tsx
// Inline rounded badge with semantic tones. Replaces ad-hoc chip styling
// scattered across the previous screens.
import type { ReactNode } from 'react';
import styles from './Pill.module.css';

export type PillTone =
  | 'neutral'
  | 'accent'
  | 'success'
  | 'warning'
  | 'danger';

interface Props {
  tone?: PillTone;
  children: ReactNode;
  className?: string;
}

export default function Pill({ tone = 'neutral', children, className }: Props) {
  const cls = [styles.pill, styles[tone], className].filter(Boolean).join(' ');
  return <span className={cls}>{children}</span>;
}
